import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getUserList as getUserListApi,
	getUser as getUserApi,
	addNewUser as addNewUserApi,
	updateUser as updateUserApi,
	deleteUser as deleteUserApi,
	privacyPolicyUser as privacyPolicyUserApi,
	passwordUser as passwordUserApi,
	infoUser as infoUserApi,
	establishmentUser as establishmentUserApi,
} from '../../helpers/auth/backend_helper';

export const getUserList = createAsyncThunk('users/getUserList', async () => {
	try {
		const response = getUserListApi();
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getUser = createAsyncThunk('users/getUser', async user_id => {
	try {
		const response = getUserApi(user_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewUser = createAsyncThunk('users/addNewUser', async user => {
	try {
		const response = addNewUserApi(user);
		toast.success('Usuario agregado exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al agregar user.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updateUser = createAsyncThunk('users/updateUser', async ({ username, user }) => {
	try {
		const response = updateUserApi({ username, user });
		return response;
	} catch (error) {
		toast.error('Error al actualizar user.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const deleteUser = createAsyncThunk('users/deleteUser', async user => {
	try {
		const response = await deleteUserApi(user);
		toast.success('Usuario eliminado exitosamente.', { autoClose: 3000 });
		return { user, ...response };
	} catch (error) {
		toast.error('Error al eliminar user.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const privacyPolicyUser = createAsyncThunk('users/privacyPolicyUser', async user => {
	try {
		const response = await privacyPolicyUserApi(user);
		return { user, ...response };
	} catch (error) {
		throw new Error(error);
	}
});

export const passwordUser = createAsyncThunk('users/passwordUser', async ({ username, password }, { rejectWithValue }) => {
	try {
		const response = await passwordUserApi({ username, password });
		return response;
	} catch (error) {
		const errorMessage = error.response?.data?.detail || 'Error al actualizar la contraseña.';
		toast.error(errorMessage, { autoClose: 3000 });
		return rejectWithValue(errorMessage);
	}
});

export const infoUser = createAsyncThunk('users/infoUser', async ({ username, user }, { rejectWithValue }) => {
	try {
		const response = await infoUserApi({ username, user });
		return response;
	} catch (error) {
		const errorMessage = error.response?.data?.detail || 'Error al actualizar la información.';
		toast.error(errorMessage, { autoClose: 3000 });
		return rejectWithValue(errorMessage);
	}
});

export const establishmentUser = createAsyncThunk('users/establishmentUser', async ({ username, user }, { rejectWithValue }) => {
	try {
		const response = await establishmentUserApi({ username, user });
		return response;
	} catch (error) {
		const errorMessage = error.response?.data?.detail || 'Error al actualizar el establecimiento';
		toast.error(errorMessage, { autoClose: 3000 });
		return rejectWithValue(errorMessage);
	}
});
